class MapLoader {
    // 1. describe and create/initiate our object
    constructor() {
        this.mapContainer = document.getElementById("g-map");
        // eslint-disable-next-line no-undef
        this.mapLocation = this.mapContainer.querySelector(".marker");

        if (this.mapContainer && this.mapLocation) {
            this.events();
        }
    }

    // 2. events
    events() {
        window.addEventListener("DOMContentLoaded", this.initMap.bind(this));
    }

    // 3. methods (function, action...)
    initMap() {
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(this.mapContainer, {
            center: {
                lat: parseFloat(this.mapLocation.dataset.lat),
                lng: parseFloat(this.mapLocation.dataset.lng),
            },
            zoom: parseInt(this.mapContainer.dataset.zoom),
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: [
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e9e9e9",
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                        {
                            lightness: 29,
                        },
                        {
                            weight: 0.2,
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                        {
                            lightness: 18,
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dedede",
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            visibility: "on",
                        },
                        {
                            color: "#ffffff",
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            saturation: 36,
                        },
                        {
                            color: "#333333",
                        },
                        {
                            lightness: 40,
                        },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f2f2f2",
                        },
                        {
                            lightness: 19,
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#fefefe",
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#fefefe",
                        },
                        {
                            lightness: 17,
                        },
                        {
                            weight: 1.2,
                        },
                    ],
                },
            ],
        });

        // Add markers to map
        // eslint-disable-next-line no-unused-vars, no-undef
        const addressLocation = new google.maps.Marker({
            position: {
                lat: parseFloat(this.mapLocation.dataset.lat),
                lng: parseFloat(this.mapLocation.dataset.lng),
            },
            map: this.map,
        });
    }
}

export default MapLoader;
